import styled from 'styled-components';

import RefreshIcon from 'components/icons/refresh';
import SecondaryButton from 'components/secondary-button';

export const RefreshButtonContainer = styled.div`
  display: flex;
  width: calc(100% - 1rem);
  max-width: 350px;
  margin: 0 auto 1rem;
  justify-content: center;

  ${Styles.mobile`
    font-size: 1.375rem;
    justify-content: center;
  `}

  ${Styles.kiosk`
    margin-top: 0;
  `};
`;

export const RefreshButton = styled(SecondaryButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.normal};
  letter-spacing: 'normal';
  text-align: center;
  letter-spacing: 0.5px;
  box-shadow: none;
  &:hover {
    box-shadow: 0px 0px 0px 3px ${Styles.color.grey.four};
  }

  ${Styles.mobile`
    margin-left: 0rem;
    margin-top: 1rem;
    width: auto;
    padding-left: 3rem;
    padding-right: 3rem;
    &:hover{
      color: ${Styles.color.primary};
      background-color: ${Styles.color.white};
    }
    &:hover svg{
      fill: ${Styles.color.primary};
    }

    &:active{
      background-color: ${Styles.color.primary};
      color: ${Styles.color.white};
    }
    &:active svg{
      fill: ${Styles.color.white};
    }
  `};

  ${Styles.desktop`
    display: block;
    margin-top: 1rem;
    width: auto;
    padding: 1rem 2rem;
  `};
`;

export const StyledRefreshIcon = styled(RefreshIcon)`
  fill: ${Styles.color.primary};
  padding-right: 7px;
`;
